// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__ICF4Z","auth__form":"Auth_auth__form__N1nzr","form__inputs":"Auth_form__inputs__zOTH7","form__btns":"Auth_form__btns__OYdke"};